module.exports = __webpack_public_path__ + "media/images/academy-thankyou-f4e19350b3f900cb6c15c8f30460d4de.png";